import { fsm, iam, pjm, sys } from '@/api/defineRouting.ts'
import type { ResponseBody } from '@/types'
import type {
  OrgUnitRequestParams,
  OrgUnitRequestParamsByRoot,
  OrgUnitSearchSdi,
} from '@/types/org-unit'

export const getCompanyList = async (params: OrgUnitRequestParams) => {
  const res: ResponseBody = await useGet(`${sys.GET_COMPANY_LIST}`, params)
  return res
}

export const getCompanyListByRoot = async (params: OrgUnitRequestParamsByRoot) => {
  const res: ResponseBody = await useGet(`${sys.GET_COMPANY_LIST_ROOT}`, params)
  return res
}

// Lấy danh sách phân loại khu vực
export const getGlobalListDetail = async (params: { code: string }) => {
  const res: ResponseBody = await useGet(`${pjm.GET_GLOBAL_LIST_DETAIL}`, params)
  return res
}

// Lấy file
export const getFile = async (params: { objectCode: string; objectId?: number }) => {
  const res: ResponseBody = await useGet(`${fsm.GET_FILE}`, params)
  return res
}

// Tải file lên
export const uploadFile = async (params: any): Promise<ResponseBody> => {
  return await usePost(`${fsm.UPLOAD_MULTIPART_FILE}`, params, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
}

export const getApplicationList = async () => {
  const res: ResponseBody = await useGet(`${iam.ALL_CLIENT}`)
  return res
}

//Lấy danh sách tỉnh thành
export const getListProvince = async () => {
  const res: ResponseBody = await usePost(`${sys.GET_PROVINCE}`, {})
  return res
}

//Lấy danh sách huyện
export const getListDistrict = async (params: any) => {
  const res: ResponseBody = await usePost(`${sys.GET_DISTRICT}`, params)
  return res
}

//Lấy danh sách xã
export const getListCommune = async (params: any) => {
  const res: ResponseBody = await usePost(`${sys.GET_COMMUNE}`, params)
  return res
}

//Lấy đối tượng theo loại đối tượng
export const getObjectListByCode = async (path: string, params: any) => {
  const res: ResponseBody = await useGet(`${path}`, { params })
  return res
}
//Lấy danh sách phòng ban thẩm định

export const getDepartment = async (params: {
  orgUnitSearchSdi: OrgUnitSearchSdi
  pageInfo?: {
    currentPage: number
    pageSize: number
  }
}) => {
  const res: ResponseBody = await usePost(`${sys.GET_ORGANIZATIONAL_LIST}`, params)
  return res
}
